export const goodsCouponModule = {
  title: "商品券",
  historyTitle: "最近使用历史",
  historyTableTitle: "商品券名",
  historyTableDate: "日期",
  historyTablePrice: "金额",
  actionButton: "商品券购买",
  moreTitle: "更多商品券",
  couponSelect: "商品券",
  couponAmountSelect: "商品券金额选择",
  usablePrice: "利用可能额：",
  usePrice: "利用额：",
  leftPrice: "剩余额：",
  useButton: "利用",
  cancelButton: "取消",
  confirmButton: "确认",
  useTip: "请将该画面出示给店员<br>确认以上内容是否正确",
  priceInputError: "金额输入错误",
  hasBuy: "已购买",
  notBuy: "未购买",
  couponUseSuccess: "感谢您的使用",
  couponBuySuccess: "购买成功",
  goCouponList: "商品券列表",
  goUseCoupon: "使用券",
  goHome: "回到首页",
  payButton: "支付",
};
